import LinkedInIntegration from 'models/application/integration/LinkedInIntegration';

export default class LinkedInIntegrationService {
	toModel(integration) {
		return new LinkedInIntegration(integration);
	}
}
